import {getStartOfDay} from '@lib/utils';
import {isSameDay} from 'date-fns';
import createCachedSelector from 're-reselect';
import {RootState} from '../../rootReducer';
import {workdaysAdapter} from './adapters';

export const {
  selectById: getWorkdayById,
  selectIds: getWorkdayIds,
  selectEntities: getWorkdayEntities,
  selectAll: getAllWorkdays,
  selectTotal: getTotalWorkdays,
} = workdaysAdapter.getSelectors((state: RootState) => state.data.workday.workdays);

export const getWorkdayByDate = createCachedSelector(
  getAllWorkdays,
  (_state: RootState, date: string | undefined) => date,
  (workdays, date) => {
    if (!date) return undefined;
    return workdays.find((workday) => isSameDay(getStartOfDay(workday.startDate), getStartOfDay(date)));
  },
)((_state, date) => date || '');

export const getIsWorkdayLoading = (state: RootState) => state.data.workday.isLoading;
